import { eXepTKBLopTCActionsObj } from "../../action-types/tkb/IXepTKBLopTCActions";
import { generateActions } from "../generateActions";

export const xepTKBLopTCActions = {
  ...generateActions(eXepTKBLopTCActionsObj, "XEP_TKB_LOP_TC"),


};
